<template lang="pug">
.neutral200
  v-container.pa-8(fluid style="max-width:1600px")
    inventory.mb-6(:purchasesMetaData="purchases" @updated="handleUpdatePurchases")
    purchases(ref="purchases" :purchasesMetaData="purchases" @updated="fetchPurchases")
</template>

<script>
import { mapGetters } from 'vuex'
import Inventory from '@/components/clinic/purchasehub/Inventory.vue'
import Purchases from '@/components/clinic/purchasehub/Purchases.vue'

export default {
  components: {
    Inventory, Purchases
  },
  data() {
    return {
      purchases: {
        isFetching: false,
        isError: false,
        data: {
          inStock: null,
          orderSoon: null,
          noStock: null,
          paymentDue: null,
          paymentOverdue: null,
          paymentPaid: null,
          stockReceived: null,
          stockRequested: null,
          transferActiveRequests: null,
          transferPendingApproval: null,
          transferFullyReceived: null,
        }
      }
    }
  },
  mounted () {
    this.fetchPurchases()
  },
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
  },
  methods: {
    async fetchPurchases () {
      try {
        this.purchases.isFetching = true
        const endpoint = `/purchases/${this.company.slug}`
        const { data } = await this.axios.get(endpoint)
        this.mapData(data)
      } catch (error) {
        this.purchases.isError = true
      } finally {
        this.purchases.isFetching = false
      }
    },
    mapData (data) {
      this.purchases.data.inStock = data?.in_stock ?? null
      this.purchases.data.orderSoon = data?.order_soon ?? null
      this.purchases.data.noStock = data?.no_stock ?? null
      this.purchases.data.paymentDue = data?.payment_due ?? null
      this.purchases.data.paymentOverdue = data?.payment_overdue ?? null
      this.purchases.data.paymentPaid = data?.payment_paid ?? null
      this.purchases.data.stockReceived = data?.stock_received ?? null
      this.purchases.data.stockRequested = data?.stock_requested ?? null
      this.purchases.data.transferActiveRequests = data?.transfer_active_requests ?? null
      this.purchases.data.transferPendingApproval = data?.transfer_pending_approval ?? null
      this.purchases.data.transferFullyReceived = data?.transfer_fully_received ?? null
    },
    handleUpdatePurchases () {
      this.$refs.purchases.fetchItems()
    }
  },
}
</script>

<style scoped>
</style>
